import React from 'react';
import MuiTextField from '@mui/material/TextField';
import {
  getFormFieldSanitizeMode,
  sanitizeFormFieldInput,
} from '../../utils/sanitizeFormText';

const SKIP_TYPES = new Set([
  'password',
  'number',
  'file',
  'hidden',
  'date',
  'datetime-local',
  'time',
  'month',
  'week',
  'color',
  'range',
]);

const SanitizedTextField = React.forwardRef(function SanitizedTextField(
  { onChange, type, select, sanitize, name, ...props },
  ref,
) {
  const mode = getFormFieldSanitizeMode(name, sanitize);
  const skip =
    mode == null ||
    select === true ||
    SKIP_TYPES.has(String(type || 'text').toLowerCase());

  const handleChange = (event) => {
    if (!skip && event?.target && typeof event.target.value === 'string') {
      const sanitized = sanitizeFormFieldInput(event.target.value, mode);
      if (sanitized !== event.target.value) {
        event.target.value = sanitized;
      }
    }
    onChange?.(event);
  };

  return (
    <MuiTextField
      ref={ref}
      name={name}
      type={type}
      select={select}
      onChange={handleChange}
      {...props}
    />
  );
});

export default SanitizedTextField;
